const selectors =
  'button, label, input, textarea, select, details, a[href], [tabindex]:not([tabindex="-1"])';

export { getFocusableElements };

/**
 *
 * @param {Document|Node} [container=document]
 * @return {T[]|*[]}
 */
function getFocusableElements(container = document) {
  try {
    const elements = container?.querySelectorAll?.(selectors) ?? [];
    return Array.from(elements).filter(
      (el) =>
        !(
          el.hasAttribute('disabled') ||
          el.getAttribute('aria-hidden') ||
          el.hasAttribute('hidden')
        ),
    );
  } catch (error) {
    console.error('getting focusable elements failure', error);
    return [];
  }
}
